import $http from "../axios";

const state = {
  //feedbacks: []
};

const getters = {};

const actions = {
  getClientCoupon(_, transactionId) {
    return new Promise((resolve, reject) => {
      $http
        .get(`get-client-coupon?transactionId=${transactionId}`)
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
